export const isRunningTests = () => {
  try {
    return '_e2e_testing' in globalThis || globalThis.process.env.MODE === 'test';
  } catch (error) {
    return false;
  }
};
